import request from "@/API/request";

// 获取政策政策信息专栏分类
export function getPunishmentList(data) {
    return request({
        url: '/resource/api/article/application/1002/page',
        method: 'get',
        params:data
    });
}

// 获取专栏新闻（分页）
export function getPunishmentPage(columnId,data) {
    return request({
        url: `/resource/api/article/column/${columnId}/page`,
        method: 'get',
        params:data
    });
}

// 获取新闻详情
export function getNewsInfo(id) {
    return request({
        url: `/resource/api/article/${id}`,
        method: 'get',
    });
}

// 新增评论
export function addComment(data) {
    return request({
        url: `/resource/api/comment`,
        method: 'post',
        data
    });
}

// 删除评论
export function delComment(id) {
    return request({
        url: `/resource/api/comment/${id}`,
        method: 'delete',
    });
}

// 获取评论
export function getComment(articleId,data) {
    return request({
        url: `/resource/api/comment/article/${articleId}`,
        method: 'get',
        params:data
    });
}

// 图片上传
export function fileUpLoad(data) {
    return request({
        url: "resource/api/upload?type=0",
        method: "post",
        headers: {
            'Content-Type': 'multipart/form-data'  // 必须设置这个请求头
        },
        data,
    });
}

// 根据区域编码code查询区域树结构数据
export function getAreaTreeData(adcode, recursion) {
    return request({
        url: `resource/api/area/adcode/${adcode}/treedata`,
        method: "get",
        params: { recursion },
    });
}

//新增企业
export function addCompony(data) {
    return request({
        url: "resource/api/companies/normal",
        method: "post",
        data
    });
}

//下载附件
export function downloadFile(data) {
    return request({
        url: "resource/api/download",
        method: "get",
        params:data,
        responseType: 'blob',
        headers: {
            'Content-Type': 'application/octet-stream',// 必须设置这个请求头
        },
    });
}

